import { Alert } from '@uy3/web-components';

type IsDirtyProps = {
  isDirty: boolean;
};

const NotSavedChangesAlert: React.FC<IsDirtyProps> = ({ isDirty }) => <>{isDirty && <Alert severity="warning" text="Existem informações não salvas" />}</>
export default NotSavedChangesAlert;
